import React, { Component } from "react";
import * as moment from "moment";
import DatePicker from "material-ui-pickers/DatePicker";
import { ToastContainer, toast } from "react-toastify";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logoutUser, validateToken } from "../../actions/user_actions/index";

// routing
import { Redirect } from "react-router-dom";

// utils
import urls from "../../utils/urls";
import api from "../../utils/api";
import { helpers } from "../../utils/helpers";
import { endpoints } from "../../utils/constants";

// assets
import CalendarIcon from "../../assets/svg/calendar-alt-regular.svg";

class Header extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    const { pathname } = window.location;
    const routes = ["analisis", "mapa", "simulador", "admin"];

    this.datePickerRef = React.createRef();

    const {
      ADMINISTRATOR,
      PRICING_STAFF,
      STATION_DM,
      STATION_TM
    } = helpers.groups;

    const allowedGroups = [
      ADMINISTRATOR,
      PRICING_STAFF,
      STATION_DM,
      STATION_TM
    ];

    this.state = {
      menu: routes.map(route =>
        pathname === "/" || pathname.includes(route) ? "active" : ""
      ),
      momentDate: moment(),
      isOpen: false,
      intervalId: null,
      taskId: null,
      download: false,
      canDownloadPrices: helpers.checkUserGroup(allowedGroups, user)
    };
  }

  componentWillMount() {
    const { user, validateToken } = this.props;

    if (user) validateToken();
  }

  componentWillUnmount() {
    const { intervalId } = this.state;

    window.clearInterval(intervalId);
  }

  componentDidMount() {
    try {
      window.materializeInit();
    } catch (e) {
      console.error("Error on materialize init.");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { taskId, momentDate } = this.state;

    if (prevState.taskId !== taskId) {
      const howOftenShouldCheck = momentDate.isBefore(new Date())
        ? 3000
        : 10000;

      const intervalId = setInterval(
        this.checkForDownload,
        howOftenShouldCheck
      );

      this.setState({ intervalId });
    }
  }

  handleLogout = e => {
    const { history, logoutUser } = this.props;

    e.preventDefault();

    history.push("/");
    logoutUser();
  };

  handleDatePickerClick = e => {
    if (this.datePickerRef.current) {
      this.datePickerRef.current.open(e);
    }
  };

  handleDateChange = momentDate => {
    this.setState({ momentDate }, () =>
      this.downloadPrices(this.state.momentDate)
    );
  };

  downloadPrices = (date = moment()) => {
    const formattedDate = date.format("YYYY-MM-DD");
    toast.success("Su descarga comenzará cuando esté lista");

    api
      .post(endpoints.exportPrices, { date: formattedDate })
      .then(({ data }) => this.setState({ taskId: data.task_id }))
      .catch(() =>
        toast.error("No se ha logrado iniciar la descarga del archivo")
      );
  };

  checkForDownload = () => {
    const { taskId, intervalId } = this.state;

    this.setState({ download: true }, () => {
      api
        .get(endpoints.exportPricesWithId(taskId))
        .then(res => {
          if (res.data.finished) {
            this.setState({ download: false });

            const fileURL = `${urls.API_ROOT}${res.data.file}`;
            window.location = fileURL;

            window.clearInterval(intervalId);
          }
        })
        .catch(e => {
          toast.error("No se pudo descargar el archivo. Inténtelo nuevamente");
          this.setState({ download: false });
        });
    });
  };

  render() {
    const { user } = this.props;
    const { menu, momentDate, canDownloadPrices } = this.state;

    const profile_url = `${urls.API_ROOT}/profile/`;
    const profile_image =
      user.profile_image !== null
        ? user.profile_image
        : "/static/imgs/shell.png";

    if (user === null) {
      return <Redirect to="/" />;
    }

    return (
      <header>
        <nav className="top-nav">
          <div className="nav-wrapper">
            <div className="">
              <div className="row no-margin vmiddle">
                <div className="row col s12 l6 nav-header">
                  <div className="col l1">
                    <a className="" href="/">
                      <img
                        src="/static/imgs/shell.png"
                        className="responsive-img"
                        alt="Shell"
                      />
                    </a>
                  </div>
                  <div className="col l11">
                    <h3 className="no-margin page_title">Prices</h3>
                    <h6 className="futura-bold page-sub-title">
                      Shell Retail Argentina
                    </h6>
                  </div>
                </div>
                <div className="col l6 hide-on-med-and-down">
                  <ul className="right main-menu-right">
                    <li className="no-padding">
                      <a
                        className="dropdown-button"
                        href=""
                        data-activates="dropdown_apps"
                        data-beloworigin="true"
                        data-alignment="right"
                        data-propagation="true"
                        data-constrainwidth="false"
                      >
                        <i className="material-icons">apps</i>
                      </a>
                      <ul
                        id="dropdown_apps"
                        className="dropdown-content doc-dropdown z-depth-0"
                      >
                        <li className="apps-li-container">
                          <div className="apps-container">
                            {user.get_tools.map(tool => {
                              return (
                                <div className="app-container" key={tool.url}>
                                  <a href={tool.url} target="_blank">
                                    <img src={tool.logo} alt={tool.name} />
                                    <p>{tool.name}</p>
                                  </a>
                                </div>
                              );
                            })}
                          </div>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a
                        className="chip dropdown-button user-menu"
                        data-activates="user_menu_drop"
                        data-beloworigin="true"
                      >
                        <img src={profile_image} alt={user.first_name} />
                        <div className="username-container name">
                          <div className="truncate">{user.first_name}</div>
                          <div className="truncate">{user.last_name}</div>
                        </div>
                      </a>
                      <ul id="user_menu_drop" className="dropdown-content">
                        <li>
                          <a
                            href={profile_url}
                            className="truncate"
                            target="_blank"
                          >
                            Ir al perfil
                          </a>
                        </li>
                        <li>
                          <a
                            href=""
                            onClick={this.handleLogout}
                            className="truncate"
                          >
                            Cerrar Sesión
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="secondary-nav container-fluid">
            <div className="row">
              <div className="col s12">
                <div className="secondary-nav_inner">
                  <a href="/" className={"secondary-nav_inner_btn " + menu[0]}>
                    Tablero de Control
                  </a>
                  <a
                    href="/analisis"
                    className={"secondary-nav_inner_btn " + menu[1]}
                  >
                    Análisis
                  </a>
                  <a
                    href="/mapa"
                    className={"secondary-nav_inner_btn " + menu[2]}
                  >
                    Mapa
                  </a>

                  {user.canSeeSimulator && (
                    <a
                      href="/simulador"
                      className={"secondary-nav_inner_btn " + menu[3]}
                    >
                      Simulador
                    </a>
                  )}

                  {helpers.checkUserGroup(
                    helpers.groups.ADMINISTRATOR,
                    user
                  ) && (
                    <a
                      href="/admin"
                      className={"secondary-nav_inner_btn " + menu[4]}
                    >
                      Administrador
                    </a>
                  )}

                  {canDownloadPrices && (
                    <div className="row no-margin vmiddle picker-container">
                      <button
                        onClick={() => this.downloadPrices()}
                        className={"secondary-nav_inner_btn right no-border"}
                      >
                        Descargar Precios
                      </button>
                      <DatePicker
                        maxDate={new Date()}
                        maxDateMessage={"La fecha debe ser una fecha pasada"}
                        cancelLabel={"Cancelar"}
                        value={momentDate}
                        format={"YYYY-MM-DD"}
                        ref={this.datePickerRef}
                        onChange={this.handleDateChange}
                        TextFieldComponent={() => (
                          <div onClick={this.handleDatePickerClick}>
                            <img src={CalendarIcon} />
                          </div>
                        )}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </nav>
        <ToastContainer />
      </header>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ logoutUser, validateToken }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/containers/base/header.js